import http from "../http/http-config";

export default new class SettingsService {

    getSettings(request): Promise<string> {
        return http.get<string>("Settings", {
            params: {
                request
            }
        }).then(response => response.data);
    }
}